import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface BigNumberProps {
  value: string;
  /** Small text right after the value, e.g. "Avg.". */
  suffix?: string;
  detail?: ReactNode;
  /** Puts the detail on the same line as the value. */
  inline?: boolean;
  className?: string;
}

export function BigNumber({ value, suffix, detail, inline = false, className }: BigNumberProps) {
  return (
    <div className={cn('mt-3', inline && 'flex items-baseline gap-1', className)}>
      <p className='text-xl font-semibold leading-7 tabular-nums text-ink'>
        {value}
        {suffix ? <span className='ml-1 text-sm font-medium'>{suffix}</span> : null}
      </p>
      {detail ? <p className='text-[13px] leading-[18px] tabular-nums text-gray-900'>{detail}</p> : null}
    </div>
  );
}
